// src/components/RegistrationHRM.jsx
import React, { useState, useEffect, useCallback, Fragment } from "react";
import apiClient from "../api/axiosClient";
import { ChevronLeft, ChevronRight, Save } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/FormProduction.css";
import SidebarGuideline from "./SidebarGuideline";
import TextField from "@mui/material/TextField";
import {downloadFile} from '../common'

// Constants for max lengths
const FIELD_MAX_LENGTH = 100;
const COMPANY_PROFILE_MAX_LENGTH = 300;
const COMMENT_MAX_LENGTH = 200;
const TEXTAREA_MAX_LENGTH = 300;
const PHONE_MAX_LENGTH = 10;
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

// Validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d{10}$/;

const RegistrationHRM = () => {
  const location = useLocation();
  // const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(null);
  const awardTitle =
    location.state?.awardTitle ||
    "Human Resource Management Company of the Year";
  const [userInfo, setUserInfo] = useState();
  const [formId, setFormId] = useState("");
  const [PkId, setPkId] = useState(0);

  // Form state initialization
  const [formData, setFormData] = useState({
    Organisationname: "",
    category: "Human Resource Management Company of the Year",
    mailingAddress: "",
    authorityName: "",
    authorityTitle: "",
    authorityPhone: "",
    authorityLandline: "",
    authorityEmail: "",
    applicant_name: "",
    applicant_phone: "",
    applicant_email: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    companyProfile: "",
    approvingAuthoritySignature: null,
    declaration: false,
    comment: "",
    ldGM: "",
    ldExecutive: "",
    ldWorkmen: "",
    ldHSE: "",
    ldSkill: "",
    ldFunctional: "",
    ldManagement: "",
    attritionEntry: "",
    attritionExecutive: "",
    attritionSenior: "",
    recruitVacancies: "",
    recruitFilled: "",
    recruitCycle: "",
    diversityTotal: "",
    diversityUnder40: "",
    diversityFemale: "",
    diversityQualified: "",
    diversityDisabled2024: "",
    diversityDisabled2023: "",
    
    pmeDone: "",
    pmeRequired: "",
    retentionFemalePast: "",
    grievanceMechanism: "",
    grievanceMechanism2: "",
    grievanceMechanism3: "",
    employeeAwards: "",
    employeeAwards2: "",
    employeeAwards3: "",
    attachments1: { description: "", file: null, url: null },
    attachments2: { description: "", file: null, url: null },
    attachments3: { description: "", file: null, url: null },
    attachments4: { description: "", file: null, url: null },
    form_mode: "draft",
    firstname: "",
    lastname: "",
    userid: "",
    company_name: "",
  });

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("user_info") || localStorage.getItem("user_info");
      if (stored) {
        const user = JSON.parse(stored);
        setUserInfo(user);
        setFormId(`HRM_Registration_${user.id}`);

        setFormData((prev) => ({
          ...prev,
          userid: user.id || "",
          firstname: user.first_name || "",
          lastname: user.last_name || "",
          company_name: user.organisation_name || "",
          Organisationname: user.organisation_name || "",
          // Fill applicant_* only
          applicant_name: user.applicant_name || "",
          applicant_phone: user.applicant_phone || "",
          applicant_email: user.email || "",
        }));
      }
    } catch (err) {
      console.warn("Failed to parse user_info from storage:", err);
    }
  }, []);

// This use Effect Prefill user Data using api;
      useEffect(() => {
        if (userInfo && formId) {
          prefillFormData();
        } else {
          console.warn(
            `userInfo OR formId is invalid; Kindly check the method. and data`
          );
        }
      }, [userInfo, formId]);
    
      const isSubmited = () => formData.form_mode === 'submit';
    
  // ---------------------------
  // PREFILL: reads /hrm-registration/?userid=...&form_id=...
  // ---------------------------
  function prefillFormData() {
    if (!userInfo || !formId) {
      console.warn("prefillFormData: missing userInfo or formId");
      return;
    }

    const url = `/hrm-registration/?user_id=${userInfo.id}&form_id=${formId}`;
    apiClient
      .get(url)
      .then((res) => {
        if (!Array.isArray(res.data) || res.data.length !== 1) {
          console.log("No prefill data found (or multiple):", res.data);
          return;
        }

        const _ResData = res.data[0];
        setPkId(_ResData.id || 0);

        // helpers
        const readFirst = (...keys) => {
          for (const k of keys) {
            if (
              Object.prototype.hasOwnProperty.call(_ResData, k) &&
              _ResData[k] !== null &&
              _ResData[k] !== undefined
            ) {
              return _ResData[k];
            }
          }
          return undefined;
        };
        const asString = (v) => (v === null || v === undefined ? "" : String(v));

        // build newFields consistent with your front-end state keys
        const newFields = {
          Organisationname: readFirst("organisation_name", "organisationName", "company_name") ?? "",
          category: readFirst("category") ?? "Human Resource Management Company of the Year",
          mailingAddress: readFirst("mailing_address", "mailingAddress") ?? "",
          authorityName: readFirst("authority_name") ?? "",
          authorityTitle: readFirst("authority_title") ?? "",
          authorityPhone: readFirst("authority_phone") ?? "",
          authorityLandline: readFirst("authorityLandline", "authority_landline") ?? "",
          authorityEmail: readFirst("authority_email") ?? "",
          applicant_name: readFirst("applicant_name", "applicantName", "contact_name") ?? "",
          applicant_phone: readFirst("applicant_phone", "applicantPhone", "contact_phone") ?? "",
          applicant_email: readFirst("applicant_email", "applicantEmail", "contact_email") ?? "",
          contact_name: readFirst("contact_name") ?? "",
          contact_phone: readFirst("contact_phone") ?? "",
          contact_email: readFirst("contact_email") ?? "",
          companyProfile: readFirst("company_profile") ?? "",
          comment: readFirst("comment") ?? "",
          declaration:
            readFirst("declaration") === true ||
            readFirst("declaration") === "true" ||
            readFirst("declaration") === 1 ||
            readFirst("declaration") === "1",
          approvingAuthoritySignature: null,
          approvingAuthoritySignatureUrl:
            readFirst("approving_authority_file", "approving_authority_file_url", "approvingAuthoritySignature", "approvingAuthoritySignatureUrl") ?? null,
          form_mode: readFirst("form_mode") ?? readFirst("formMode") ?? "draft",
          firstname: readFirst("firstname", "first_name") ?? "",
          lastname: readFirst("lastname", "last_name") ?? "",
          userid: readFirst("userid") ?? readFirst("user") ?? "",
          company_name: readFirst("company_name") ?? "",
        };

        // numeric fields mapping (stateKey -> likely backend field same name)
        const numericFieldMap = {
          ldGM: "ldGM",
          ldExecutive: "ldExecutive",
          ldWorkmen: "ldWorkmen",
          ldHSE: "ldHSE",
          ldSkill: "ldSkill",
          ldFunctional: "ldFunctional",
          ldManagement: "ldManagement",
          attritionEntry: "attritionEntry",
          attritionExecutive: "attritionExecutive",
          attritionSenior: "attritionSenior",
          recruitVacancies: "recruitVacancies",
          recruitFilled: "recruitFilled",
          recruitCycle: "recruitCycle",
          diversityTotal: "diversityTotal",
          diversityUnder40: "diversityUnder40",
          diversityFemale: "diversityFemale",
          diversityQualified: "diversityQualified",
          diversityDisabled2024: "diversityDisabled2024",
          diversityDisabled2023: "diversityDisabled2023",
          // diversityDisabled2024: "differently_abled_employees_ass_year",
          pmeDone: "pmeDone",
          pmeRequired: "pmeRequired",
          retentionFemalePast: "retentionFemalePast",
        };

        // read numeric fields and convert to strings for controlled inputs
        Object.entries(numericFieldMap).forEach(([stateKey, apiKey]) => {
          const snake = apiKey.replace(/([A-Z])/g, "_$1").toLowerCase();
          const lower = apiKey.toLowerCase();
          const val = readFirst(apiKey, snake, lower);
          newFields[stateKey] = asString(val);
        });

        // text blocks
        newFields.grievanceMechanism = readFirst("grievanceMechanism", "grievance_mechanism") ?? "";
        newFields.grievanceMechanism2 = readFirst("grievanceMechanism2", "grievance_mechanism2") ?? "";
        newFields.grievanceMechanism3 = readFirst("grievanceMechanism3", "grievance_mechanism3") ?? "";
        newFields.employeeAwards = readFirst("employeeAwards", "employee_awards") ?? "";
        newFields.employeeAwards2 = readFirst("employeeAwards2", "employee_awards2") ?? "";
        newFields.employeeAwards3 = readFirst("employeeAwards3", "employee_awards3") ?? "";

        // attachments 1..4: keep description, file:null (user picks) and url for preview if present
        for (let n = 1; n <= 4; n++) {
          const desc = readFirst(`attachments${n}_desc`, `attachments${n}Desc`, `attachments${n}_description`) ?? "";
          const urlVal = readFirst(`attachments${n}`, `attachments${n}_url`, `attachments${n}Url`) ?? null;
          newFields[`attachments${n}`] = {
            description: desc,
            file: null,
            url: urlVal,
          };
        }

        // apply immutably
        setFormData((prev) => ({ ...prev, ...newFields }));
        console.log("HRM prefill applied, pkId:", _ResData.id);
      })
      .catch((err) => {
        console.error("prefillFormData error:", err);
      });
  }

  // UI State
  const [currentStep, setCurrentStep] = useState(1);
  const [copyApplicantData, setCopyApplicantData] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");

  // Validation helpers
  const validateEmail = (email) => emailRegex.test(email);
  const validatePhone = (phone) => phoneRegex.test(phone);

  // Clear error on field
  const clearFieldError = useCallback((field) => {
    setFieldErrors((prev) => {
      if (prev[field]) {
        const { [field]: omitted, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  }, []);

  // Handle changes for inputs/textareas/selects
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if ([1, 2, 3, 4].includes(currentStep)) {
      let applicableMaxLength = FIELD_MAX_LENGTH;
      if (name === "companyProfile") applicableMaxLength = COMPANY_PROFILE_MAX_LENGTH;
      else if (name === "comment") applicableMaxLength = COMMENT_MAX_LENGTH;
      else if (
        [
          "grievanceMechanism",
          "grievanceMechanism2",
          "grievanceMechanism3",
          "employeeAwards",
          "employeeAwards2",
          "employeeAwards3",
        ].includes(name)
      ) {
        applicableMaxLength = TEXTAREA_MAX_LENGTH;
      }

      if (typeof value === "string") {
        if (name === "companyProfile") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed.");
            return;
          }
        } else if (name === "comment") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words allowed in Comments.");
            return;
          }
        } else if (["grievanceMechanism", "grievanceMechanism2", "grievanceMechanism3", "employeeAwards", "employeeAwards2", "employeeAwards3"].includes(name)) {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed ");
            return;
          }
        } else if (value.length > applicableMaxLength) {
          alert(`Value cannot exceed ${applicableMaxLength} characters.`);
          return;
        }
      }

      if (type === "number") {
        if (value === "") {
          clearFieldError(name);
        } else {
          const numVal = Number(value);
          if (numVal < 0) {
            alert("Value cannot be negative.");
            return;
          } else {
            clearFieldError(name);
          }
        }
      }
    } else {
      clearFieldError(name);
    }

    // Name validation
    if (["Organisationname", "authorityName", "contact_name"].includes(name)) {
      const isValid = /^[A-Za-z\s]*$/.test(value);
      if (!isValid && value !== "") {
        alert("Only letters and spaces are allowed.");
        return;
      }
    }

    // Phone validation
    if (name === "authorityPhone" || name === "contact_phone") {
      const numericValue = value.replace(/\D/g, "").slice(0, PHONE_MAX_LENGTH);
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
      clearFieldError(name);
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));

    if (name === "Organisationname" && value && currentStep === 1) setError("");
    if (name === "mailingAddress" && value.trim() && currentStep === 1) setError("");
    if (name === "authorityName" && value && currentStep === 2) setError("");
    if (name === "authorityTitle" && value && currentStep === 2) setError("");
    if (name === "authorityEmail" && value && currentStep === 2) setError("");
    if (name === "authorityPhone" && value && currentStep === 2) setError("");
  };

  // Handle checkbox for copying applicant data
  const handleCopyApplicantToggle = (e) => {
    const checked = e.target.checked;
    const model = { contact_name: "", contact_phone: "", contact_email: "" };

    if (checked) {
      const ui = sessionStorage.getItem("user_info") || localStorage.getItem("user_info");
      if (ui) {
        const userInfoLocal = JSON.parse(ui);
        model.contact_name = userInfoLocal.applicant_name || "";
        model.contact_phone = userInfoLocal.applicant_phone || "";
        model.contact_email = userInfoLocal.email || "";
      }
    }

    setFormData((prev) => ({ ...prev, ...model }));
    setCopyApplicantData(checked);
    clearFieldError("contact_name");
    clearFieldError("contact_phone");
    clearFieldError("contact_email");
  };

  // Handle attachment changes
  const handleAttachmentChange = (key, field, value, event = null) => {
    if (field === "file" && value) {
      const file = value;
      const maxSizeInBytes = MAX_FILE_SIZE;
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, PNG, and PDF files are allowed for attachments.");
        if (event) event.target.value = null;
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert("File size must not exceed 5 MB for attachments.");
        if (event) event.target.value = null;
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
    clearFieldError(key);
  };

  // Handle approving authority signature upload
  const handleApprovingAuthorityChange = (files) => {
    const file = files[0];
    if (file) {
      const maxSizeInBytes = MAX_FILE_SIZE;
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, PNG, and PDF files are allowed for the signature.");
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert("File size must not exceed 5 MB for the signature.");
        return;
      }
      setFormData((prev) => ({ ...prev, approvingAuthoritySignature: file }));
      clearFieldError("approvingAuthoritySignature");
    }
  };
// Replace your current renderQuantitativePrint with this:
const renderQuantitativePrint = (sectionStart, sectionEnd) => {
  let html = "";
  const filteredData = data.filter(
    (section) => Number(section.num) >= Number(sectionStart) && Number(section.num) <= Number(sectionEnd)
  );

  // helper to safely get label text (handles plain strings vs React nodes)
  const getLabelText = (item, section) => {
    if (typeof item.label === "string") return item.label;
    // if it's a React element (Fragment / JSX), fallback to section.title or empty string
    if (item.label && typeof item.label === "object") {
      // try to extract a simple string from props.children if it's a string or array of strings
      try {
        const child = item.label.props?.children;
        if (typeof child === "string") return child;
        if (Array.isArray(child)) {
          // join string children; ignore React nodes
          return child.map(c => (typeof c === "string" ? c : "")).join(" ");
        }
      } catch (e) {
        // ignore and fallback
      }
      return section.title || "";
    }
    return item.label ?? section.title ?? "";
  };

  filteredData.forEach((section) => {
    const items = section.subItems || section.fields || [];
    items.forEach((item) => {
      const num = item.num ?? "";
      const label = getLabelText(item, section);
      // if item.key is empty or missing, print an empty value cell
      const rawVal = item.key ? (formData[item.key] ?? "") : "";
      // convert to a safe string for HTML (basic escaping)
      const value = String(rawVal)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

      html += `
        <tr>
          <td style="border: 1px solid #000; padding: 8px;">${num}</td>
          <td style="border: 1px solid #000; padding: 8px;">${label}</td>
          <td style="border: 1px solid #000; padding: 8px;">${value}</td>
        </tr>
      `;
    });
  });

  return html;
};

  // const handlePrint = () => {

    

  //   const printContent = `
  //     <div style="font-family: Arial, sans-serif; padding: 20px;">
  //       <h1 style="text-align: center; color: #1e40af;">${awardTitle}</h1>
  //       <h2>Organization & Contact Details</h2>
  //       <p><strong>Organisation Name:</strong> ${formData.Organisationname || ""}</p>
  //       <p><strong>Postal Address:</strong> ${formData.mailingAddress || ""}</p>
  //       <p><strong>Approving Authority Name:</strong> ${formData.authorityName || ""}</p>
  //       <p><strong>Approving Authority Designation:</strong> ${formData.authorityTitle || ""}</p>
  //       <p><strong>Approving Authority Landline:</strong> ${formData.authorityLandline || ""}</p>
  //       <p><strong>Approving Authority Phone:</strong> ${formData.authorityPhone || ""}</p>
  //       <p><strong>Approving Authority Email:</strong> ${formData.authorityEmail || ""}</p>
  //       <h2>Nodal Official Contact Details:</h2>
  //       <p><strong>Contact Name:</strong> ${formData.contact_name || ""}</p>
  //       <p><strong>Contact Phone:</strong> ${formData.contact_phone || ""}</p>
  //       <p><strong>Contact Email:</strong> ${formData.contact_email || ""}</p>
  //       <p><strong>Brief write-up on company’s profile:</strong> ${formData.companyProfile || ""}</p>
  //       <h2>Quantitative Information - Part 1</h2>
  //       <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
  //         <thead>
  //           <tr>
  //             <th style="border: 1px solid #000; padding: 8px;">S.No</th>
  //             <th style="border: 1px solid #000; padding: 8px;">Particulars</th>
  //             <th style="border: 1px solid #000; padding: 8px;">Assessment Year</th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           ${/* reuse minimal representation */ ""}
  //         </tbody>
  //       </table>
  //       <h2>Attachments</h2>
  //       <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
  //         <thead>
  //           <tr>
  //             <th style="border: 1px solid #000; padding: 8px; width:10px">S.No</th>
  //             <th style="border: 1px solid #000; padding: 8px;">Description</th>
  //             <th style="border: 1px solid #000; padding: 8px;">File Name</th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           ${[1, 2, 3, 4]
  //             .map(
  //               (i) => `
  //             <tr>
  //               <td style="border: 1px solid #000; padding: 8px;">${i}</td>
  //               <td style="border: 1px solid #000; padding: 8px;">${formData[`attachments${i}`].description || ""}</td>
  //               <td style="border: 1px solid #000; padding: 8px;">${formData[`attachments${i}`].file?.name || ""}</td>
  //             </tr>
  //           `
  //             )
  //             .join("")}
  //         </tbody>
  //       </table>
  //       <h2>Comments</h2>
  //       <p>${formData.comment || ""}</p>
  //       <h2>Declaration</h2>
  //       <p>I declare that the information submitted is true and complete.</p>
  //       <p><strong>Approving Authority Name:</strong> ${formData.authorityName || ""}</p>
  //       <p><strong>Approving Authority Designation:</strong> ${formData.authorityTitle || ""}</p>
  //     </div>
  //   `;

  //   const printWindow = window.open("", "_blank", "height=600,width=800");
  //   printWindow.document.write(`
  //     <!DOCTYPE html>
  //     <html>
  //       <head><meta charset="UTF-8"><title>${awardTitle || "Form Print"}</title></head>
  //       <body>${printContent}</body>
  //     </html>
  //   `);
  //   printWindow.document.close();
  //   printWindow.print();
  // };

  // Navigation handlers
  // const renderQuantitativePrint = (sectionStart, sectionEnd) => {
  //   let html = "";
  //   const filteredData = data.filter(
  //     (section) => section.num >= sectionStart && section.num <= sectionEnd
  //   );
  //   filteredData.forEach((section) => {
  //     const items = section.subItems || section.fields;
  //     items.forEach((item, index) => {
  //       html += 
  //         <tr>
           
  //           <td style="border: 1px solid #000; padding: 8px;">${
  //             item.num || ""
  //           }</td>
  //           <td style="border: 1px solid #000; padding: 8px;">${
  //             item.label || section.title
  //           }</td>
  //           <td style="border: 1px solid #000; padding: 8px;">${
  //             formData[item.key] || ""
  //           }</td>
  //         </tr>
  //       ;
  //     });
  //   });
  //   return html;
  // };

  const handlePrint = () => {
  const grievanceAnswer = formData.grievanceMechanism || "No";
  const grievanceDetails =
    grievanceAnswer === "Yes" ? formData.grievanceMechanism2 || "—" : "";

  const awardsAnswer = formData.employeeAwards || "No";
  const awardsDetails =
    awardsAnswer === "Yes" ? formData.employeeAwards2 || "—" : "";

  const printContent = `
    <div style="font-family: Arial, sans-serif; padding: 20px;">
      <h1 style="text-align: center; color: #1e40af;">${awardTitle}</h1>
      <h2>Organization & Contact Details</h2>
      <p><strong>Organisation Name:</strong> ${formData.Organisationname || ""}</p>

      <h2>Nodal Official Contact Details:</h2>
      <p><strong>Postal Address:</strong> ${formData.mailingAddress || ""}</p>
      <p><strong>Approving Authority Name:</strong> ${formData.authorityName || ""}</p>
      <p><strong>Approving Authority Title:</strong> ${formData.authorityTitle || ""}</p>
      <p><strong>Approving Authority Landline:</strong> ${formData.authorityLandline || ""}</p>
      <p><strong>Approving Authority Phone:</strong> ${formData.authorityPhone || ""}</p>
      <p><strong>Approving Authority Email:</strong> ${formData.authorityEmail || ""}</p>

      <p><strong>Contact Name:</strong> ${formData.contact_name || ""}</p>
      <p><strong>Contact Phone:</strong> ${formData.contact_phone || ""}</p>
      <p><strong>Contact Email:</strong> ${formData.contact_email || ""}</p>
      <p><strong>Brief write-up on company’s profile:</strong> ${formData.companyProfile || ""}</p>

      <h2>Quantitative Information - Part 1</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;">S.No</th>
            <th style="border: 1px solid #000; padding: 8px;">Particulars</th>
            <th style="border: 1px solid #000; padding: 8px;">Assessment Year</th>
          </tr>
        </thead>
        <tbody>
          ${renderQuantitativePrint(1, 5)}
        </tbody>
      </table>

      <h2>Quantitative Information - Part 2</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;">S.No</th>
            <th style="border: 1px solid #000; padding: 8px;">Particulars</th>
            <th style="border: 1px solid #000; padding: 8px;">Assessment Year</th>
          </tr>
        </thead>
        <tbody>
          ${renderQuantitativePrint(6, 7)}
        </tbody>
      </table>

      
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;">S.No</th>
            <th style="border: 1px solid #000; padding: 8px;">Description</th>
            <th style="border: 1px solid #000; padding: 8px;">Response</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="border: 1px solid #000; padding: 8px;">8.1</td>
            <td style="border: 1px solid #000; padding: 8px;">Grievance Redressal Mechanism
Does the company provide a channel through which employees can report suspected grievances, and does the channel allow for confidential and/or anonymous reporting (Yes/No); If yes provide details in bullet points (within 300 words)</td>
            <td style="border: 1px solid #000; padding: 8px;">${grievanceAnswer}</td>
          </tr>
          ${
            grievanceAnswer === "Yes"
              ? `
                <tr>
                  <td style="border: 1px solid #000; padding: 8px;">8.2</td>
                  <td style="border: 1px solid #000; padding: 8px;">Details</td>
                  <td style="border: 1px solid #000; padding: 8px;">${grievanceDetails}</td>
                </tr>
              `
              : ""
          }
          <tr>
            <td style="border: 1px solid #000; padding: 8px;">9.1</td>
            <td style="border: 1px solid #000; padding: 8px;">	Recognition & Award Programmes for Employees
Details (in bullet points) of awards/recognitions programmes active within the organization for employees in the year 2024-25 (Within 300 words)</td>
            <td style="border: 1px solid #000; padding: 8px;">${awardsAnswer}</td>
          </tr>
          ${
            awardsAnswer === "Yes"
              ? `
                <tr>
                  <td style="border: 1px solid #000; padding: 8px;">9.2</td>
                  <td style="border: 1px solid #000; padding: 8px;">Details</td>
                  <td style="border: 1px solid #000; padding: 8px;">${awardsDetails}</td>
                </tr>
              `
              : ""
          }
        </tbody>
      </table>

      <h2>Attachments</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;">S.No</th>
            <th style="border: 1px solid #000; padding: 8px;">Description</th>
            <th style="border: 1px solid #000; padding: 8px;">File Name</th>
          </tr>
        </thead>
        <tbody>
          ${[1, 2, 3, 4]
            .map(
              (i) => `
            <tr>
              <td style="border: 1px solid #000; padding: 8px;">${i}</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[`attachments${i}`].description || ""
              }</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[`attachments${i}`].file?.name || ""
              }</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>

      <h2>Comments</h2>
      <p>${formData.comment || ""}</p>

      <h2>Declaration</h2>
      <p>I declare that the information submitted is true and complete.</p>
      <br/>
      <p><strong>Approving Authority Name:</strong> ${formData.authorityName || ""}</p>
      <p><strong>Approving Authority Title:</strong> ${formData.authorityTitle || ""}</p>
      <p><strong>Signed on:</strong> ${formData.signatureDate || new Date().toLocaleDateString()}</p>
      <p><strong>Approving Authority Signature:</strong></p>
    </div>
  `;

  const printWindow = window.open("", "_blank", "height=600,width=800");
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <title>${awardTitle || "Form Print"}</title>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.print();
};
  
  
  
  
  const nextStep = () => {
    if (currentStep === 1) {
      if (!formData.mailingAddress.trim()) {
        alert("Mailing address is required.");
        return;
      }
    }
    if (currentStep === 2) {
      if (!formData.authorityName) {
        alert("Authority name is required.");
        return;
      }
      if (!formData.authorityTitle) {
        alert("Authority designation is required.");
        return;
      }
      if (!formData.authorityEmail || !validateEmail(formData.authorityEmail)) {
        alert("Please enter a valid Authority email.");
        return;
      }
      if (!formData.authorityLandline) {
        alert("Authority Landline is required.");
        return;
      }
      if (!formData.contact_name) {
        alert("Contact name is required.");
        return;
      }
      if (formData.contact_email && !validateEmail(formData.contact_email)) {
        alert("Please enter a valid Contact email.");
        return;
      }
      if (formData.contact_phone && !validatePhone(formData.contact_phone) && !copyApplicantData) {
        alert("Contact phone must be exactly 10 digits.");
        return;
      }
      if (!formData.companyProfile) {
        alert("Company profile is required.");
        return;
      }
    }
    if (currentStep === 3 && areFieldsEmpty()) {
      if (!window.confirm("Data not entered, If you wish to continue?")) {
        return;
      }
    }

    if (currentStep === 4 && areFieldsEmpty()) {
      if (!window.confirm("Data not entered, If you wish to continue?")) {
        return;
      }
    }

    if (Object.values(fieldErrors).some(Boolean)) {
      alert("Please resolve all errors before continuing.");
      return;
    }

    setError("");
    if (currentStep < 5) setCurrentStep((prev) => prev + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep((prev) => prev - 1);
  };

  // Save draft handler
  const handleSaveDraft = () => {
    localStorage.setItem(
      "registrationhrmDraft",
      JSON.stringify({ formData })
    );
    handleSubmit(null);
    alert("Draft Saved!");
  };

  // Submit wrapper used by button: validates important checks then posts
  const onFinalSubmitClick = async (e) => {
    e?.preventDefault();
    if (!formData.declaration) {
      return alert("Please accept the declaration before submitting.");
    }
    if (!formData.approvingAuthoritySignature) {
      return alert("Please upload the approving authority signature file.");
    }
    if (!window.confirm("Are you sure you want to submit?")) {
      return;
    }
    try {
      await handleSubmit(null, "submit");
      setIsSubmitted(true);
      alert("HRM registration submitted successfully!");
    } catch (err) {
      console.error("Final submit failed:", err);
      // user alert is already performed in handleSubmit
    }
  };

  // ---------------------------
  // SUBMIT: builds FormData and posts to /hrm-registration/
  // Returns axios response on success, throws on error
  // ---------------------------
  // UPDATED handleSubmit (paste in place of your original)
async function handleSubmit(event, clickType = "draft") {
  if (event && event.preventDefault) event.preventDefault();

  // local copy and merge user_info synchronously (no state set here)
  const payload = { ...formData };
  try {
    const raw = sessionStorage.getItem("user_info") || localStorage.getItem("user_info");
    if (raw) {
      const u = JSON.parse(raw);
      payload.userid = payload.userid || (u.id ? String(u.id) : "");
      payload.firstname = payload.firstname || u.first_name || "";
      payload.lastname = payload.lastname || u.last_name || "";
      payload.company_name = payload.company_name || u.organisation_name || "";
      payload.Organisationname = payload.Organisationname || u.organisation_name || "";
    }
  } catch (err) {
    console.warn("Failed to read user_info:", err);
  }

  // --- KEY FIX: map frontend key(s) to backend expected keys so numericList finds them
  // prefer explicit front-end value but fallback to any server-prefill keys already present
  const frontVal = payload.diversityDisabled2024 ?? payload.differently_abled_employees_ass_year ?? payload.diversityDisabled2023 ?? payload.pmeDone ?? "";
  // Normalize to string (keep empty string if nothing)
  const normalized = (frontVal === null || frontVal === undefined) ? "" : String(frontVal).trim();

  // Ensure backend keys exist in payload so numericList will append them
  payload.differently_abled_employees_ass_year = payload.differently_abled_employees_ass_year ?? normalized;
  payload.diversityDisabled2023 = payload.diversityDisabled2023 ?? normalized;
  payload.pmeDone = payload.pmeDone ?? normalized;

  try {
    const fd = new FormData();

    // Identity & contact fields (names exactly as model expects)
    fd.append("organisation_name", payload.Organisationname || payload.organisation_name || "");
    fd.append("category", payload.category || "");
    fd.append("firstname", payload.firstname || "");
    fd.append("lastname", payload.lastname || "");
    fd.append("userid", payload.userid || "");
    fd.append("company_name", payload.company_name || "");
    fd.append("mailing_address", payload.mailingAddress || payload.mailing_address || "");

    // Authority & contact
    fd.append("authority_name", payload.authorityName || payload.authority_name || "");
    fd.append("authority_title", payload.authorityTitle || payload.authority_title || "");
    fd.append("authority_phone", payload.authorityPhone || payload.authority_phone || "");
    // NOTE: your model uses field name "authorityLandline" (exact)
    fd.append("authorityLandline", payload.authorityLandline || payload.authority_landline || "");
    fd.append("authority_email", payload.authorityEmail || payload.authority_email || "");

    // optional copy_applicant_data boolean (if present)
    if (typeof payload.copy_applicant_data !== "undefined") {
      fd.append("copy_applicant_data", payload.copy_applicant_data ? "true" : "false");
    }

    fd.append("contact_name", payload.contact_name || "");
    fd.append("contact_phone", payload.contact_phone || "");
    fd.append("contact_email", payload.contact_email || "");

    // qualitative
    fd.append("company_profile", payload.companyProfile || payload.company_profile || "");
    fd.append("comment", payload.comment || "");
    fd.append("declaration", payload.declaration ? "true" : "false");

    // form meta required by back-end
    fd.append("form_id", formId);
    fd.append("form_mode", clickType);
    if (PkId > 0) fd.append("id", PkId);

    // approving authority signature file (file object)
    if (payload.approvingAuthoritySignature instanceof File) {
      if (payload.approvingAuthoritySignature.size > MAX_FILE_SIZE) {
        throw new Error("Approving authority signature exceeds maximum file size.");
      }
      fd.append("approving_authority_file", payload.approvingAuthoritySignature);
    }

    // numeric fields (stringify)
    const numericList = [
      "ldGM",
      "ldExecutive",
      "ldWorkmen",
      "ldHSE",
      "ldSkill",
      "ldFunctional",
      "ldManagement",
      "attritionEntry",
      "attritionExecutive",
      "attritionSenior",
      "recruitVacancies",
      "recruitFilled",
      "recruitCycle",
      "diversityTotal",
      "diversityUnder40",
      "diversityFemale",
      "diversityQualified",
      "diversityDisabled2024",
      "diversityDisabled2023",
      "differently_abled_employees_ass_year", // <-- backend name
      "pmeDone",
      "pmeRequired",
      "retentionFemalePast",
    ];
    numericList.forEach((k) => {
      const v = payload[k];
      fd.append(k, v !== undefined && v !== null ? String(v) : "");
    });

    // text fields
    fd.append("grievanceMechanism", payload.grievanceMechanism || "");
    fd.append("grievanceMechanism2", payload.grievanceMechanism2 || "");
    fd.append("grievanceMechanism3", payload.grievanceMechanism3 || "");
    fd.append("employeeAwards", payload.employeeAwards || "");
    fd.append("employeeAwards2", payload.employeeAwards2 || "");
    fd.append("employeeAwards3", payload.employeeAwards3 || "");

    // attachments 1..4: description + file
    for (let n = 1; n <= 4; n++) {
      const slot = payload[`attachments${n}`] || { description: "", file: null };
      fd.append(`attachments${n}_desc`, slot.description || "");
      const file = slot.file;
      if (file instanceof File) {
        if (file.size > MAX_FILE_SIZE) {
          throw new Error(`Attachment ${n} exceeds max size (${MAX_FILE_SIZE / (1024 * 1024)} MB)`);
        }
        fd.append(`attachments${n}`, file);
      }
    }

    // DEBUG (optional) - uncomment to inspect before sending:
    // for (const pair of fd.entries()) console.log("FD:", pair[0], pair[1]);

    // POST — axios will set multipart headers automatically
    const resp = await apiClient.post("/hrm-registration/", fd);

    // refresh prefill to pick up saved id and preview urls
    await prefillFormData();

    return resp;
  } catch (err) {
    console.error("HRM submission error:", err);
    const serverMsg = err?.response?.data ?? err?.message ?? String(err);
    // if server returns object of field errors, flatten into message:
    let message = serverMsg;
    if (serverMsg && typeof serverMsg === "object") {
      const parts = [];
      for (const [k, v] of Object.entries(serverMsg)) {
        parts.push(`${k}: ${Array.isArray(v) ? v.join(" | ") : String(v)}`);
      }
      message = parts.join("\n");
    }
    alert("Submission failed: " + JSON.stringify(message));
    throw err;
  }
}

   const viewFile =  async (serverPath) => {
    // "https://award-backend.fipi.org.in/media/
    const extractPath = serverPath.split('/').filter(
  (val) =>
    val !== "" && // remove empty strings
    val !== "http:" &&
    val !== "https:" &&
    val !== "media" &&
    !val.startsWith("award") &&
    !val.startsWith("localhost")
).join('/');
    
    downloadFile(extractPath)
  }
  // Quantitative data for steps 3 and 4 (unchanged)
  const data = [
    {
      num: 1,
      subItems: [
        { num: "1", label: "Learning & Development(Total no. of training days imparted to such employees/no. of such employees at the mentioned level)" },
        { num: "1.1", label: "GM and above", key: "ldGM" },
        { num: "1.2", label: "Executive (up to E-6 level in PSU or equivalent)", key: "ldExecutive" },
        { num: "1.3", label: "Workmen", key: "ldWorkmen" },
        { num: "1.4", label: "Total HSE training days", key: "ldHSE" },
        { num: "1.5", label: "No. of training days per employee (Excluding HSE) for each of the following:", key: "" },
        { num: "1.5.1", label: "Skill Development Training", key: "ldSkill" },
        { num: "1.5.2", label: "Functional/On-job Training", key: "ldFunctional" },
        { num: "1.5.3", label: "Management Training", key: "ldManagement" },
      ],
    },
    {
      num: 2,
      subItems: [
        { num: "2", label: "Employee attrition rate (other than retirement)" },
        { num: "2.1", label: "Entry level (within first two years of joining) ", key: "attritionEntry" },
        { num: "2.2", label: "Executives (up to E-6 level in PSU or equivalent)", key: "attritionExecutive" },
        { num: "2.3", label: "Senior Management (E-7 & above or equivalent) ", key: "attritionSenior" },
      ],
    },
    {
      num: 3,
      subItems: [
        { num: "3", label: "% Recruitment (Full Time; Regular Employee)" },
        { num: "3.1", label: "Total vacancies identified for recruitment to be during the year", key: "recruitVacancies" },
        { num: "3.2", label: "Total no of positions filled during the year through hiring", key: "recruitFilled" },
      ],
    },
    {
      num: 4,
      subItems: [
        { num: "4", label: "Recruitment Cycle Completion (Avg. no. of days from when the job requisition was received until the offer was accepted by the candidate) " },
        { num: "4.1", label: "Recruitment Cycle Completion", key: "recruitCycle" },
      ],
    },
    {
      num: 5,
      subItems: [
        { num: "5", label: "Diverse workforce (as on 31st March)" },
         { num: "-", label: "Total No. of Employees",key:"diversityTotal" },
        { num: "5.1", label: "No. of Employees under 40 years", key: "diversityUnder40" },
        { num: "5.2", label: "No. of Female employees", key: "diversityFemale" },
        { num: "5.3", label: "No of Employees having higher qualification (post graduates & above)", key: "diversityQualified" },
        { num: "5.4", label: "No. of Differently-abled employees (assessment yr)", key: "diversityDisabled2024" },
        { num: "5.4", label: "No. of Differently-abled employees (previous yr)", key: "diversityDisabled2023" },
      ],
    },

   
    
    {
      num: 6,
      subItems: [
        { num: "6", label: "Preventive Medical Examination (PME)" },
        { num: "6.1", label: "No. of Employees undergone Preventive Medical Examination (PME) during the year", key: "pmeDone" },
        { num: "6.2", label: "No. of Employees who were to undergo PME as per company policy during the year ", key: "pmeRequired" },
      ],
    },
    {
      num: 7,
      subItems: [
        { num: 7, label: "Progress in Retaining Female Workforce" },
        { num: "7.1", label: "No. of Female Employees Five Years ago", key: "retentionFemalePast" },
      ],
    },
    {
      num: 8,
      subItems: [
        { num: "8", label: (<Fragment><strong>Grievance Redressal Mechanism</strong><p>Does the company provide a channel through which employees can report suspected grievances, and does the channel allow for confidential and/or anonymous reporting (Yes/No); If yes provide details in bullet points (within 300 words)</p></Fragment>) },
        // { num: "8.1", key: "grievanceMechanism2" },
        // { num: "8.2", key: "grievanceMechanism2" },
      ],
    },
    {
      num: 9,
      subItems: [
        { num: "9", label: (<Fragment><strong>Recognition & Award Programmes for Employees</strong><p>Details (in bullet points) of awards/recognitions programmes active within the organization for employees in the year 2024-25 (Within 300 words)</p></Fragment>) },
        // { num: "9.1", key: "employeeAwards2" },
        // { num: "9.2", key: "employeeAwards2" },
      ],
    },
  ];

  // const areFieldsEmpty = (start, end) => {
  //   const filteredData = data.filter((section) => Number(section.num) >= start && Number(section.num) <= end);
  //   for (const section of filteredData) {
  //     const items = section.subItems || [];
  //     for (const item of items) {
  //       if (!item.key) continue;
  //       const val = formData[item.key];
  //       if (val === undefined || val === null || val === "") return true;
  //       if (Array.isArray(val) && val.some((v) => v === "" || v === null || v === undefined)) return true;
  //     }
  //   }
  //   return false;
  // };

// Replace your existing areFieldsEmpty with this
const areFieldsEmpty = (start, end) => {
  const ranges = { 3: [1, 5.4], 4: [6, 9] };

  // determine range
  let s = start, e = end;
  if (s === undefined || e === undefined) {
    if (ranges[currentStep]) [s, e] = ranges[currentStep];
    else return false; // nothing to validate
  }

  const isEmpty = (val) => {
    if (val === undefined || val === null) return true;
    if (typeof val === "string" && val.trim() === "") return true;
    if (Array.isArray(val) && val.some(v => v === undefined || v === null || (typeof v === "string" && v.trim() === ""))) return true;
    return false;
  };

  // --- EXPLICIT CHECK FOR SECTIONS 8 & 9 (parents + children) ---
  // If the requested range includes section 8 or 9, validate them explicitly
  if (Number(s) <= 9 && Number(e) >= 8) {
    // grievanceMechanism (section 8)
    const gm = formData.grievanceMechanism;
    if (gm === undefined || gm === null || gm === "") {
      console.log("Missing: grievanceMechanism (section 8 parent)");
      return true;
    }
    // If parent is "No" we still consider it "missing" per your rule
    if (gm === "No") {
      console.log("grievanceMechanism is 'No' -> treated as missing");
      return true;
    }
    // if "Yes" then the details textarea must be filled
    if (gm === "Yes") {
      if (isEmpty(formData.grievanceMechanism2)) {
        console.log("grievanceMechanism2 (8.1) is empty");
        return true;
      }
    }

    // employeeAwards (section 9)
    const ea = formData.employeeAwards;
    if (ea === undefined || ea === null || ea === "") {
      console.log("Missing: employeeAwards (section 9 parent)");
      return true;
    }
    if (ea === "No") {
      console.log("employeeAwards is 'No' -> treated as missing");
      return true;
    }
    if (ea === "Yes") {
      if (isEmpty(formData.employeeAwards2)) {
        console.log("employeeAwards2 (9.1) is empty");
        return true;
      }
    }
  }

  // --- GENERIC VALIDATION FOR OTHER FIELDS IN data ---
  const filtered = data.filter(section => {
    const n = Number(section.num);
    return !isNaN(n) && n >= Number(s) && n <= Number(e);
  });

  for (const section of filtered) {
    const items = section.subItems || section.fields || [];
    for (const item of items) {
      // skip items that don't have a key (your parent rows for 8/9 are such; we already handled them)
      if (!item || !item.key) continue;
      const key = item.key;
      const val = formData[key];

      // If this is a conditional child ending with '2', require it only if parent === "Yes"
      if (/2$/.test(key)) {
        const parentKey = key.replace(/2$/, "");
        if (formData[parentKey] !== "Yes") continue;
      }

      if (isEmpty(val)) {
        console.log("Missing generic field:", key);
        return true;
      }
    }
  }

  return false; // nothing missing
};



  const renderSection = (section) => {
    const items = section.subItems || section.fields || [];
    const headerNums = ["1", "1.5", "2", "3", "4", "5", "6", "7"];
    
    return items.map((item) => {
      const rowNum = (item?.num ?? "").toString();
      const isHeader = headerNums.includes(rowNum);


      if (section.num === 8) {
    return (
      <>
        <tr>
          <td className="sno-cell">{section.subItems?.[0]?.num ?? ""}</td>
          <td className="label-cell">{section.subItems?.[0]?.label ?? ""}</td>
          <td>
            <div className="yes-no-toggle">
              <button
                type="button"
                onClick={() =>
                  handleChange({ target: { name: "grievanceMechanism", value: "Yes" } })
                }
                className={`form-button ${formData.grievanceMechanism === "Yes" ? "active" : ""}`}
              >
                Yes
              </button>
              <button
                type="button"
                onClick={() =>
                  handleChange({ target: { name: "grievanceMechanism", value: "No" } })
                }
                className={`form-button ${formData.grievanceMechanism === "No" ? "active" : ""}`}
              >
                No
              </button>
 
              {fieldErrors.grievanceMechanism && (
                <span className="error-tooltip" id="grievanceMechanism-error" role="alert">
                  {fieldErrors.grievanceMechanism}
                </span>
              )}
            </div>
          </td>
        </tr>
 
        {formData.grievanceMechanism === "Yes" && (
          <tr>
            <td className="sno-cell">{section.subItems?.[1]?.num ?? "8.1"}</td>
            <td colSpan={2}>
              <textarea
                name="grievanceMechanism2"
                value={formData.grievanceMechanism2 || ""}
                onChange={handleChange}
                className="form-input"
                rows={4}
              />
              {fieldErrors.grievanceMechanism2 && (
                <span className="error-tooltip" id="grievanceMechanism2-error" role="alert">
                  {fieldErrors.grievanceMechanism2}
                </span>
              )}
            </td>
          </tr>
        )}
      </>
    );
  }
 
 
  if (section.num === 9) {
    return (
      <>
        <tr>
          <td className="sno-cell">{section.subItems?.[0]?.num ?? ""}</td>
          <td className="label-cell">{section.subItems?.[0]?.label ?? ""}</td>
          <td>
            <div className="yes-no-toggle">
              <button
                type="button"
                onClick={() =>
                  handleChange({ target: { name: "employeeAwards", value: "Yes" } })
                }
                className={`form-button ${formData.employeeAwards === "Yes" ? "active" : ""}`}
              >
                Yes
              </button>
              <button
                type="button"
                onClick={() =>
                  handleChange({ target: { name: "employeeAwards", value: "No" } })
                }
                className={`form-button ${formData.employeeAwards === "No" ? "active" : ""}`}
              >
                No
              </button>
 
              {fieldErrors.employeeAwards && (
                <span className="error-tooltip" id="employeeAwards-error" role="alert">
                  {fieldErrors.employeeAwards}
                </span>
              )}
            </div>
          </td>
        </tr>
 
        {formData.employeeAwards === "Yes" && (
          <tr>
            <td className="sno-cell">{section.subItems?.[1]?.num ?? "9.1"}</td>
            <td colSpan={2}>
              <textarea
                name="employeeAwards2"
                value={formData.employeeAwards2 || ""}
                onChange={handleChange}
                className="form-input"
                rows={4}
              />
              {fieldErrors.employeeAwards2 && (
                <span className="error-tooltip" id="employeeAwards2-error" role="alert">
                  {fieldErrors.employeeAwards2}
                </span>
              )}
            </td>
          </tr>
        )}
      </>
    );
  }

      if (isHeader) {
        return (
          <tr key={`${section.num}-${rowNum || Math.random()}`} style={{ fontWeight: "bold" }}>
            <td className="sno-cell">{item.num || ""}</td>
            <td className="label-cell" colSpan={2}>
              {item.label || section.title}
            </td>
          </tr>
        );
      }

      return (
        <tr key={`${section.num}-${rowNum || Math.random()}`}>
          <td className="sno-cell">{item.num || ""}</td>
          <td className="label-cell">{item.label || section.title}</td>
          {item.key === "" ? (
            <td>
              
            </td>
          ) : (
            <td>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                type="text"
                name={item.key}
                value={formData[item.key] || ""}
                onChange={(e) => {
                  let val = e.target.value;
                  val = val.replace(/[^0-9.]/g, "");
                  const parts = val.split(".");
                  if (parts.length > 2) {
                    val = parts[0] + "." + parts.slice(1).join("");
                  }
                  handleChange({ target: { name: e.target.name, value: val } });
                }}
                onKeyDown={(e) => {
                  if (["-", "+", "e", "E"].includes(e.key) || e.key === "ArrowUp" || e.key === "ArrowDown") {
                    e.preventDefault();
                  }
                }}
                onWheel={(e) => e.target.blur()}
                className="form-input"
                aria-describedby={`${item.key}-error`}
                inputProps={{
                  inputMode: "decimal",
                  pattern: "[0-9]*\\.?[0-9]*",
                  min: 0,
                }}
              />
              {fieldErrors[item.key] && (
                <span className="error-tooltip" id={`${item.key}-error`} role="alert">
                  {fieldErrors[item.key]}
                </span>
              )}
            </td>
          )}
        </tr>
      );
    });
  };

  const renderStepContent = () => {
    const progress = ((currentStep - 1) / 4) * 100;

    return (
      <div className="form-step" role="form" aria-label={`Step ${currentStep} of 5`}>
        <div className="progress-bar" aria-hidden="true">
          <div className="progress" style={{ width: `${progress}%` }} />
        </div>

        {currentStep === 1 && (
          <>
            <h3 className="step-title">Step 1: Organization Details</h3>
            <div className="form-group">
              <label htmlFor="Organisationname">Organisation Name:</label>
              <input
                id="Organisationname"
                name="Organisationname"
                type="text"
                maxLength={FIELD_MAX_LENGTH}
                value={formData.Organisationname}
                disabled={true}
                aria-describedby="Organisationname-error"
                className={`form-input ${!formData.Organisationname && currentStep === 1 ? "has-error" : ""}`}
                placeholder="Enter organisation name"
                required
              />
              {!formData.Organisationname && currentStep === 1 && (
                <span className="error-tooltip" id="Organisationname-error" role="alert">
                  Organisation name is required
                </span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="mailingAddress">
                Postal Address <span aria-hidden="true" className="text-red">*</span>
              </label>
              <textarea
                id="mailingAddress"
                name="mailingAddress"
                value={formData.mailingAddress}
                rows={3}
                maxLength={FIELD_MAX_LENGTH}
                onChange={handleChange}
                aria-describedby="mailingAddress-error"
                placeholder="Enter postal address"
                className={`form-textarea ${!formData.mailingAddress.trim() && currentStep === 1 ? "has-error" : ""}`}
                required
              />
              {!formData.mailingAddress.trim() && currentStep === 1 && (
                <span className="error-tooltip" id="mailingAddress-error" role="alert">
                  Mailing address is required
                </span>
              )}
            </div>
          </>
        )}

        {currentStep === 2 && (
          <>
            <h3 className="step-title">Step 2: Approving Authority & Contact</h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <section aria-labelledby="approving-authority-heading" className="step-section">
                <h4 id="approving-authority-heading">Approving Authority</h4>
                <p className="note">Approving authority should be concerned Director /Board level executive.</p>
                <div className="form-group">
                  <label htmlFor="authorityName">Name <span className="text-red">*</span></label>
                  <input id="authorityName" name="authorityName" type="text" maxLength={FIELD_MAX_LENGTH} value={formData.authorityName} onChange={handleChange} className={`form-input ${!formData.authorityName && currentStep === 2 ? "has-error" : ""}`} placeholder="Name" required />
                </div>

                <div className="form-group">
                  <label htmlFor="authorityTitle">Designation <span className="text-red">*</span></label>
                  <input id="authorityTitle" name="authorityTitle" type="text" maxLength={FIELD_MAX_LENGTH} value={formData.authorityTitle} onChange={handleChange} className={`form-input ${!formData.authorityTitle && currentStep === 2 ? "has-error" : ""}`} placeholder="Designation" required />
                </div>

                <div className="form-group">
                  <label htmlFor="authorityLandline">Landline: <span className="text-red">*</span></label>
                  <input id="authorityLandline" type="number" name="authorityLandline" value={formData.authorityLandline} onChange={handleChange} className={`form-input ${!formData.authorityLandline && currentStep === 2 ? "has-error" : ""}`} placeholder="Landline number" aria-required="true" />
                </div>

                <div className="form-group">
                  <label htmlFor="authorityPhone">Mobile:</label>
                  <input id="authorityPhone" type="tel" name="authorityPhone" value={formData.authorityPhone} onChange={handleChange} className="form-input" placeholder="Phone number" maxLength={PHONE_MAX_LENGTH} />
                </div>

                <div className="form-group">
                  <label htmlFor="authorityEmail">Email <span className="text-red">*</span></label>
                  <input id="authorityEmail" name="authorityEmail" type="email" maxLength={FIELD_MAX_LENGTH} value={formData.authorityEmail} onChange={handleChange} className={`form-input ${!formData.authorityEmail && currentStep === 2 ? "has-error" : ""}`} placeholder="Approving authority's email" required />
                </div>
              </section>

              <section aria-labelledby="contacts-heading" className="step-section">
                <h4 id="contacts-heading">Contacts (Nodal Officials) <span className="text-red">*</span></h4>
                <div className="form-group">
                  <label><input type="checkbox" name="copyApplicantData" onChange={handleCopyApplicantToggle} /> Same as applicant</label>
                </div>

                <div className="form-group">
                  <label htmlFor="contact_name">Name <span className="text-red">*</span></label>
                  <input id="contact_name" name="contact_name" type="text" maxLength={FIELD_MAX_LENGTH} value={formData.contact_name} onChange={handleChange} placeholder="Contact name" disabled={copyApplicantData} className={`form-input ${!formData.contact_name && currentStep === 2 ? "has-error" : ""}`} required />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_phone">Phone: <span className="text-red">*</span></label>
                  <input id="contact_phone" name="contact_phone" type="tel" maxLength={PHONE_MAX_LENGTH} value={formData.contact_phone} onChange={handleChange} disabled={copyApplicantData} placeholder="10-digit phone number" className={`form-input ${!formData.contact_phone && currentStep === 2 ? "has-error" : ""}`} required />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_email">Email</label>
                  <input id="contact_email" name="contact_email" type="email" maxLength={FIELD_MAX_LENGTH} value={formData.contact_email} onChange={handleChange} disabled={copyApplicantData} placeholder="Contact email" className={`form-input ${fieldErrors.contact_email ? "has-error" : ""}`} />
                </div>
              </section>
            </div>

            <div className="form-group">
              <label htmlFor="companyProfile">Brief write-up on company’s profile</label>
              <p className="note">(within 300 words)</p>
              <textarea id="companyProfile" name="companyProfile" value={formData.companyProfile} rows={6} onChange={handleChange} className="form-textarea" placeholder="Enter company profile" />
            </div>
          </>
        )}

        {currentStep === 3 && (
          <div className="quantitative-form">
            {data.filter((section) => section.num >= 1 && section.num <= 5).length > 0 && (
              <table className="quant-table">
                <thead>
                  <tr><th>S.No</th><th>Particulars</th><th>Assessment Year</th></tr>
                </thead>
                <tbody>
                  {data.filter((section) => section.num >= 1 && section.num <= 5.4).map((section) => renderSection(section))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {currentStep === 4 && (
          <div className="quantitative-form">
            {data.filter((section) => section.num >= 6 && section.num <= 9).length > 0 && (
              <table className="quant-table">
                <thead>
                  <tr><th>S.No</th><th>Particulars</th><th>Assessment Year</th></tr>
                </thead>
                <tbody>
                  {data.filter((section) => section.num >= 6 && section.num <= 9).map((section) => renderSection(section))}
                </tbody>
              </table>
            )}

            <div className="form-group">
              <label htmlFor="comment">Comments</label>
              <textarea id="comment" name="comment" value={formData.comment || ""} onChange={handleChange} className="form-textarea" rows={4} />
            </div>
          </div>
        )}

        {currentStep === 5 && (
          <>
            <h3 className="step-title">Step 5: Attachments & Declaration</h3>

            <div className="form-group">
              <label>List of Attachments (Optional):</label>
              <table className="quant-table">
                <thead>
                  <tr><th>S. No.</th><th>Description</th><th>Upload (jpg, png, pdf; max 5 MB)</th></tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    const attachment = formData[key] || { description: "", file: null };
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input type="text" name={`${key}.description`} value={attachment.description} onChange={(e) => handleAttachmentChange(key, "description", e.target.value)} placeholder="Enter description" maxLength={FIELD_MAX_LENGTH} className="form-input" />
                        </td>
                        <td>
                          <input type="file" accept=".jpg,.png,.pdf" onChange={(e) => handleAttachmentChange(key, "file", e.target.files[0], e)} className="form-input mt-4" />
                          {attachment.file && <p className="file-name">Selected file: {attachment.file.name}</p>}
                          {attachment.url && !attachment.file && (
  <p className="file-name">
    Uploaded file:{" "}
    <button
      type="button"
      onClick={() => viewFile(attachment.url)}
      style={{ background: "none", border: "none", padding: 0, color: "#06c", cursor: "pointer", textDecoration: "underline" }}
    >
      View
    </button>
  </p>
)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="form-group">
              <label>Print the completed application form and upload it with the signature of the approving authority. Without signature of the approving authority, application will not be considered valid.</label>
              <div className="form-navigation">
                <button type="button" onClick={handlePrint} className="btn btn-outline">Print Preview</button>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="approvingAuthoritySignature">Upload Document with Approving Authority Signature (Director/Board Level) <span className="text-red">*</span> :</label>
              <input
                type="file"
                id="approvingAuthoritySignature"
                accept=".jpg,.png,.pdf"
                onChange={(e) => {
                  const files = e.target.files;
                  if (files.length > 0) {
                    const confirmed = window.confirm("Are you sure the form is approved and signed by approving authority?");
                    if (!confirmed) {
                      e.target.value = "";
                      return;
                    }
                    handleApprovingAuthorityChange(files);
                  }
                }}
                className={`form-input mt-4 ${fieldErrors.approvingAuthoritySignature ? "has-error" : ""}`}
                required
              />
              {formData.approvingAuthoritySignature && <p className="file-name">Selected file: {formData.approvingAuthoritySignature.name}</p>}
               {formData.approvingAuthoritySignatureUrl && !formData.approvingAuthoritySignature && (
    <p className="file-name">
      Uploaded file:{" "}
      <button
        type="button"
        onClick={() => viewFile(formData.approvingAuthoritySignatureUrl)}
        style={{ background: "none", border: "none", padding: 0, color: "#06c", cursor: "pointer", textDecoration: "underline" }}
      >
        View
      </button>
    </p>
  )}
            </div>

            <div className="form-group">
              <label>
                <input id="declaration" type="checkbox" name="declaration" checked={formData.declaration} onChange={handleChange} className={`form-checkbox ${fieldErrors.declaration ? "has-error" : ""}`} required /> I declare that the information submitted is true and complete.
              </label>
            </div>
          </>
        )}
      </div>
    );
  };

  useEffect(() => {
    const middlePosition = window.innerHeight / 2; // middle
    window.scrollTo({ top: middlePosition + 100, behavior: "smooth" });
  }, [currentStep]);

  const navigate = useNavigate();
  return (
    <div className="sidebar-guideline-container">
      <SidebarGuideline isOpen={true} sidebarItems={[{ id: "Guideline", label: "Guideline" }]} activeItem={activeItem} setActiveItem={setActiveItem} selectedAwardCategory={formData.category} />
      <div className="application-form">
        <div className="form-header">
          <h1>{awardTitle}</h1>
          <h6>Step {currentStep} of 5</h6>
        </div>
        {error && <div className="error">{error}</div>}
        {isSubmitted ? (
          <div className="thank-you-message">
            <h2>Thank you for your submission!</h2>
            <p>Your Application has been successfully submitted.</p>
           <button onClick={() => navigate('/#Award%20Categories')}>
  Submit Another Application
</button>
          </div>
        ) : (
          <form onSubmit={(e) => e.preventDefault()}>
            {renderStepContent()}
            {currentStep === 1 && (
              <div className="form-navigation-step1">
                <button type="button" onClick={handleSaveDraft} className="btn btn-outline" disabled={isSubmited()}>
                  <Save size={16} /> Save Draft
                </button>
                <button type="button" onClick={nextStep} className="btn btn-primary">Next <ChevronRight size={16} /></button>
              </div>
            )}
            {currentStep > 1 && (
              <div className="form-navigation">
                <button type="button" onClick={prevStep} className="btn btn-outline"><ChevronLeft size={16} /> Previous</button>
                <button type="button" onClick={handleSaveDraft} className="btn btn-outline" disabled={isSubmited()}><Save size={16} /> Save Draft</button>
                {currentStep < 5 && <button type="button" onClick={nextStep} className="btn btn-primary">Next <ChevronRight size={16} /></button>}
                {currentStep === 5 && (
                  <button type="button" className="btn btn-success" disabled={isSubmited()} onClick={onFinalSubmitClick}>Submit</button>
                )}
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default RegistrationHRM;
